<template>
  <div class="main">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'MainView'
}
</script>

<style scoped>
.main {
  flex: 1;
  background-color: #eeeeee;
}
</style>
